// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContactButton_contact__38ENp","contact__text":"ContactButton_contact__text__3oJ09","contact__text_emphasized":"ContactButton_contact__text_emphasized__1nM0J"};